export default __webpack_public_path__ + "static/media/Grid-1.c07fc3c0.jpg";